import { ReportEntry } from '../../../../../../domain/report/ReportEntry';
import * as R from 'ramda';
import { customSort } from '../customSort';
import { reportUnit } from './reportUnit';

export const reportUnitList = (report: ReportEntry[]): (number | string)[] =>
  R.compose(R.sort(customSort), R.uniq, R.map(reportUnit))(report);
